export const VERSION_APP = '1.3.3';
export const HOME_DIR = '/';
export const ENV = {
    PROD: {
        API_BASE_URL1: 'https://script.google.com/macros/s/AKfycbxQfOD0VzwiR2gVbTQHqtPvsoZ_bNivrQFB2ipcBvuf5OafxR_wlEAFpXK8fgh4fDy3rA/exec',
        LIFF_ID1: '2006711844-2GZrmA3A',
        FLEX_IMAGE1: 'https://i.postimg.cc/jdVpMWLD/flex.png'
    }
}

export const CURRENT_ENV = ENV.PROD;